module.exports = __webpack_public_path__ + "static/media/main-bg.0c6aecc5.png";